import React from "react";
import RecapView from "../components/RecapView";

export default function KeepRecap() {
  return (
    <RecapView
      apiBase="/keeps-recap"
      title="Ringkasan Keep Aktif"
      subtitle="Keep berstatus aktif (Active / Partially Converted); nilai keep + HPP dari master varian & estimasi profit per grup/produk"
      exportPrefix="keep-aktif"
    />
  );
}
